import { patchReminderSignRequestLoanLenderBorrowerContract } from '@nemuru-eng/js-api-client';

import { UseDialogProps } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/LoanApplicationActionDialog';
import { StandardActionDialog } from '@/components/shared/components/StandardActionDialog/StandardActionDialog';
import { Text } from '@/components/shared/components/Text';
import { useRequest } from '@/hooks/requests/useRequest';

interface ResendContractSignatureToBorrowerDialogProps {
  loanApplicationId: string;
  useDialogProps: UseDialogProps;
}

export const ResendContractSignatureToBorrowerDialog = ({
  loanApplicationId,
  useDialogProps,
}: ResendContractSignatureToBorrowerDialogProps) => {
  const { request, loading } = useRequest();
  const resendContractSignatureToBorrower = async () => {
    await request(patchReminderSignRequestLoanLenderBorrowerContract, { id: loanApplicationId });
    useDialogProps.toggleDialog();
  };

  return (
    <StandardActionDialog
      titleTextElement={<Text tId={'RESEND_CONTRACT_SIGNATURE_TO_BORROWER'} />}
      actionDescriptionTextElement={<Text tId={'ARE_YOU_SURE_YOU_WANT_TO_RESEND_CONTRACT_SIGNATURE_TO_BORROWER'} />}
      opened={useDialogProps.opened}
      setOpened={useDialogProps.setOpened}
      loading={loading}
      setActionDialogParams={undefined}
      actionButtonsArray={[
        {
          onClick: () => resendContractSignatureToBorrower(),
          buttonLabelTextId: 'RESEND_CONTRACT',
        },
      ]}
    />
  );
};
